import { type PropsWithChildren } from "react";

import { TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";

import { SELECTION_COLUMN_WIDTH, NAME_COLUMN_ID } from "../constants";

export const TableHeaderCell = (
  props: PropsWithChildren<TableHeaderRow.CellProps>,
) => (
  <TableHeaderRow.Cell
    {...props}
    style={
      props.column.name === NAME_COLUMN_ID
        ? { left: `${SELECTION_COLUMN_WIDTH}px` }
        : {}
    }
  />
);
